import React from "react";
import Count from "components/crm/ui/Count";

// Grey pill tabs ("All 9", "To do 6").
const PillTabs = ({ tabs, value, onChange, size = "md" }) => (
  <div className="flex flex-wrap items-center gap-0.5">
    {tabs.map((t) => (
      <button
        key={t.id}
        type="button"
        disabled={t.disabled}
        onClick={() => onChange(t.id)}
        className={`flex items-center gap-1.5 rounded-md px-3 font-title font-medium transition-colors ${
          size === "lg" ? "py-2.5" : "py-2"
        } text-sm ${
          value === t.id
            ? "bg-surfaceMuted text-body"
            : "text-[#6b7280] hover:bg-gray-50 hover:text-body active:bg-surfaceMuted"
        } disabled:opacity-50`}
      >
        {t.label}
        {t.count !== undefined && t.count !== null && (
          <Count muted={!t.count}>{t.count}</Count>
        )}
      </button>
    ))}
  </div>
);

export default PillTabs;
